import React from 'react'
import styled from 'styled-components'
import { ONBOARD_TYPE, BREAKPOINT } from './constants'

import { Card } from './components/styles'
import webLogo from '../../lib/assets/icons/web-logo.svg'
import appleLogo from '../../lib/assets/icons/apple-logo.svg'
import windowsLogo from '../../lib/assets/icons/windows-logo.svg'
import googlePlayLogo from '../../lib/assets/icons/google-play-store-logo.svg'

const GSPContainer = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  display:flex;
  flex-direction: column;
  align-items:center;
  h2 {
    font-family: SpaceGrotesk, sans-serif;
    margin-top: 0;
    margin-bottom: 60px;
    font-size: 36px;
    font-weight: 500;
    text-align: center;
  } 
  p {
    margin-top: -20px;
    font-size: 16px;
  }
`

const SukiContainer = styled.div`
  width: 100%;
  min-height: 600px;
  padding: 10px 20px;
  display:flex;
  flex-direction: column;
  align-items:center;
  justify-content: space-between;
  font-family: 'Open Sans', sans-serif;
  h1 {
    font-size: 44px;
    text-align: center;
  }
  h2 {
    font-size: 20px;
    line-height: 1.38;
    text-align: center;
  }
  h3 {
    font-size: 19px;
    text-align: center;
  }
  p {
    font-size: 12px;
    margin-bottom: 10px;
  }
    
  color: white;
  & h1, & h2 {
    color: white;
  }
`

const TopContent = styled.div`
  width: 60%;
  height: 28vh; 
  min-height: 210px;
  padding: 10px;
  display:flex;
  flex-direction: column;
  align-items:center;
  h1 {
    margin-bottom: 10px;
  }
  h2 {
    margin: 10px;
  }
  @media (max-width: ${BREAKPOINT.MEDIUM_LARGE}) {
    height: 30vh; 
  } 
  @media (max-width: ${BREAKPOINT.SMALL}) {
    height: 40vh; 
  } 
`

const MiddleContent = styled.div`
  width: 100%;
  height: 37vh; 
  min-height: 220px;
  margin: 30px 0; 
  display:flex;
  flex-direction: row;
  align-items:center;
  justify-content: space-around;
  @media (max-width: ${BREAKPOINT.MEDIUM_LARGE}) {
    flex-direction: column;
    height: 85vh; 
  } 
  @media (max-width: ${BREAKPOINT.SMALL}) {
    height: 70vh; 
  }   
`
const BottomContent = styled.div`
  width: 100%;
  height: 10vh; 
  display:flex;
  flex-direction: column;
  align-items:center;
  justify-content: flex-end;
`

const AppDownloadContainer = styled.div`
  height: 100%;
  width: 100%;
  padding: 0 10px;
  display:flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  border-right: ${props => (props.borderRight && '0.5px outset black')};
  @media (max-width: ${BREAKPOINT.MEDIUM_LARGE}) {
    border: none;
    margin-bottom: 30px;
  }
`

const DownloadTitleContainer = styled.div`
  height: 25%;
  display:flex;
  flex-direction: row;
  align-items:flex-top;
  justify-content: space-around;
  font-size: 44px;
  @media (max-width: ${BREAKPOINT.MEDIUM_LARGE}) {
    height: 30%;
  }
`
const DownloadTextContainer = styled.div`
  height: 27%;
  display:flex;
  flex-direction: row;
  align-items: flex-top;
  justify-content: space-around;
  font-size: 19px;
  text-align: center;
  @media (max-width: ${BREAKPOINT.MEDIUM_LARGE}) {
    height: 30%;
  }
`
const ButtonsContainer = styled.div`
  display:flex;
  flex-direction: row;
  align-items: flex-top;
  justify-content: space-around;
`

const Button = styled.a`
  width: 130px;
  height: 35px;
  display:flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 10px 15px;
  font-size: 18px;
  font-weight: 300;
  text-align: center;
  cursor: pointer;
  text-decoration: none;
  color: white;
  background: black;
  border-radius: 6px;
  
  img {
    margin-right: 5px;
  }

  &:hover {
    background-color: rgba(0,0,0,0.8);
    color: white;
  }
`

const getWindowsDownloadLink = () => {
  let env = window.location.hostname
  // if app runs on localhost or some other env 'app.suki-dev.com' link will be used
  if (env !== 'app.suki-test.com' &&
    env !== 'app.suki-stage.com' &&
    env !== 'app.suki.ai') env = 'app.suki-dev.com'
  return `https://storage.googleapis.com/windows-${env}/SukiAssistantSetup.msi`
}

const DownloadSukiAppComponent = () => {
  return (
    <>
      <AppDownloadContainer borderRight>
        <DownloadTitleContainer>
          Mobile
        </DownloadTitleContainer>
        <DownloadTextContainer>
          Use anywhere with an internet connection.
        </DownloadTextContainer>
        <ButtonsContainer>
          <Button href='https://apps.apple.com/us/app/suki/id1425102117'>
            <img src={appleLogo} height='60%' width='25%' />
            iOS
          </Button>
          <Button href='https://play.google.com/store/apps/details?id=com.suki.suki'>
            <img src={googlePlayLogo} height='55%' width='20%' />
            Android
          </Button>
        </ButtonsContainer>
      </AppDownloadContainer>

      <AppDownloadContainer borderRight>
        <DownloadTitleContainer>
          Web
        </DownloadTitleContainer>
        <DownloadTextContainer>
          Full Assistant experience in a larger form factor.
        </DownloadTextContainer>
        <Button href='https://app.suki.ai/'>
          <img src={webLogo} height='65%' width='25%' />
          Web
        </Button>
      </AppDownloadContainer>

      <AppDownloadContainer>
        <DownloadTitleContainer>
          Windows
        </DownloadTitleContainer>
        <DownloadTextContainer>
          Dictation in any application.
        </DownloadTextContainer>
        <Button href={getWindowsDownloadLink()}>
          <img src={windowsLogo} height='50%' width='20%' />
          Windows
        </Button>
      </AppDownloadContainer>
    </>
  )
}

const GCPSuccess = () => {
  return (
    <Card>
      <GSPContainer>
        <h2>Success!</h2>
        <p>Thanks for signing your organization up for Suki. Please check your email for further instructions.</p>
      </GSPContainer>
    </Card>
  )
}

const SukiSuccess = () => {
  return (
    <SukiContainer>
      <TopContent>
        <h1>Congratulations!</h1>
        <h2>
          Your account has been successfully created.
          You’re ready to start using Suki Assistant to save time on administrative tasks.
        </h2>
        <h2>
          Start using Suki now on:
        </h2>
      </TopContent>
      <MiddleContent>
        <DownloadSukiAppComponent />
      </MiddleContent>
      <BottomContent>
        <p>
          The Suki name and logo are trademarks of Suki AI, Inc.
          All other trademarks are the property of their respective owners. © 2023 Suki AI, Inc.
        </p>
      </BottomContent>
    </SukiContainer>
  )
}

const Success = (props) => {
  const { type } = props
  return (
    type === ONBOARD_TYPE.GCP ? <GCPSuccess /> : <SukiSuccess />
  )
}

export default Success
